module.exports = __webpack_public_path__ + "img/no-word-logo.068e1297.png";